import { StyleSheet, Text, View, ViewStyle } from "react-native";
import { ProgressChart } from "react-native-chart-kit";
import { Typography, Colors } from "../../styles";

const data = {
  data: [0.4],
  colors: ["red"],
};

const Stats = ({ style }: { style?: ViewStyle }) => {
  return (
    <View style={[styles.container, style]}>
      <View style={styles.stat}>
        <View style={styles.statData}>
          <Text style={Typography.cardTitle}>8987</Text>
        </View>

        <Text style={Typography.paragraph}>Total observations</Text>
      </View>
      <View style={styles.stat}>
        <View style={styles.statData}>
          {/* https://heyoka.medium.com/scratch-made-svg-donut-pie-charts-in-html5-2c587e935d72 */}
          <svg
            viewBox="0 0 42 42"
            className="donut"
            style={{ width: 90, height: 90 }}
          >
            <circle
              className="donut-hole"
              cx="21"
              cy="21"
              r="15.91549430918954"
              fill={Colors.plum900}
            />
            <circle
              className="donut-ring"
              cx="21"
              cy="21"
              r="15.91549430918954"
              fill="transparent"
              stroke={"rgba(0,192,192,0.4)"}
              stroke-width="2.5"
            />
            <circle
              className="donut-segment"
              cx="21"
              cy="21"
              r="15.91549430918954"
              fill="transparent"
              stroke={"rgba(0,192,192,1)"}
              stroke-width="2.5"
              stroke-dasharray="65 35"
              stroke-dashoffset="0"
            />
          </svg>
          <Text style={[Typography.paragraph, { position: "absolute" }]}>
            65%
          </Text>
        </View>

        <Text style={Typography.paragraph}>Avg. visibility score</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-around",
  },
  stat: {
    alignItems: "center",
    position: "relative",
  },
  statData: {
    height: 100,
    width: 100,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default Stats;
